<ion-slides *ngIf="!loading; else loadingTemplate" class="ion-margin-top" [options]="sliderOptions">
  <!-- Add -->
  <ion-slide *ngIf="showAddCard && !viewOnlyMode">
    <ion-card class="image-placeholder">
      <ion-button class="add" [disabled]="captureInProgress || isDisabled" (click)="requestCapture()" color="tetratech">
        <ion-icon slot="start" name="add-circle-outline"></ion-icon>
        {{ addLabel }}
      </ion-button>
      <img alt="Upload/Select" src="/assets/custom-icons/upload-image.png" />
    </ion-card>
  </ion-slide>

  <!-- Photos -->
  <ion-slide *ngFor="let p of photos; trackBy: trackPhoto">
    <ion-card>
      <div class="title title-captured">{{ p.title || 'Photo' }}</div>
      <img [alt]="p.fileName || 'Photo'" [src]="p.src" />

      <span *ngIf="!viewOnlyMode && enableRemove" class="icon remove-icon" (click)="requestRemove(p, $event)">
        <ion-icon name="close-outline"></ion-icon>
      </span>

      <span *ngIf="!viewOnlyMode && enableEdit" class="icon edit-icon" (click)="requestEdit(p)">
        <ion-icon name="options-outline"></ion-icon>
      </span>
    </ion-card>
  </ion-slide>

  <!-- Tag placeholders (optional) -->
  <ng-container *ngFor="let tag of tags">
    <ion-slide *ngIf="!tag.fulfilled">
      <ion-card class="image-placeholder" [ngStyle]="{ 'border-color': tag.required ? 'red' : '#989898' }">
        <div class="title">
          {{ tag.title }}<span *ngIf="tag.required" style="color: red">*</span>
        </div>

        <ion-button
          *ngIf="!viewOnlyMode"
          class="add"
          [disabled]="captureInProgress"
          (click)="requestCapture(tag)"
          color="tetratech"
        >
          <ion-icon slot="start" name="add-circle-outline"></ion-icon>
          Select
        </ion-button>

        <img alt="Upload/Select" src="/assets/custom-icons/upload-image.png" />
      </ion-card>
    </ion-slide>
  </ng-container>
</ion-slides>

<ng-template #loadingTemplate>
  <div class="images-loading-container">
    <ion-spinner name="crescent" color="primary"></ion-spinner>
    <ion-label>Loading images...</ion-label>
  </div>
</ng-template>